/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminUpdateCourseOptions, AdminUpdateCourseStatus200, AdminUpdateCourseStatus422 } from '../models/AdminUpdateCourse'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { adminUpdateCourse } from '../clients/axios/adminUpdateCourse'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const adminUpdateCourseMutationKey = () => [{ url: '/admin/course/:course_id' }] as const

export function adminUpdateCourseMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = adminUpdateCourseMutationKey()
  return mutationOptions<AdminUpdateCourseStatus200, ResponseErrorConfig<AdminUpdateCourseStatus422>, AdminUpdateCourseOptions, TContext>({
    mutationKey,
    mutationFn: async({ path, body }) => {
      return await adminUpdateCourse({ ...config, path, body, throwOnError: true })
    },
  })
}

/**
 * @summary Update Course
 * {@link /admin/course/:course_id}
 */
export function useAdminUpdateCourse<TContext>(options: {
  mutation?: UseMutationOptions<AdminUpdateCourseStatus200, ResponseErrorConfig<AdminUpdateCourseStatus422>, AdminUpdateCourseOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? adminUpdateCourseMutationKey()

  const baseOptions = adminUpdateCourseMutationOptions(config) as UseMutationOptions<AdminUpdateCourseStatus200, ResponseErrorConfig<AdminUpdateCourseStatus422>, AdminUpdateCourseOptions, TContext>

  return useMutation<AdminUpdateCourseStatus200, ResponseErrorConfig<AdminUpdateCourseStatus422>, AdminUpdateCourseOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<AdminUpdateCourseStatus200, ResponseErrorConfig<AdminUpdateCourseStatus422>, AdminUpdateCourseOptions, TContext>
}
